var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Equals, IsBoolean, IsString, Matches } from 'class-validator';
/**
 * Body of `POST /ai-documentation/activation` (Spec § 9). Both booleans must be
 * literally `true`: the two checkboxes of the dialog are not optional, and a
 * body without them is a bug in the caller, not a "not yet confirmed" state.
 */
export class ActivateAiDocumentationDto {
    /** The `LegalDocument` version the dialog showed, e.g. `v1`. */
    textVersion;
    confirmedRead;
    declaresAuthority;
}
__decorate([
    IsString(),
    Matches(/^v\d+$/),
    __metadata("design:type", String)
], ActivateAiDocumentationDto.prototype, "textVersion", void 0);
__decorate([
    IsBoolean(),
    Equals(true),
    __metadata("design:type", Boolean)
], ActivateAiDocumentationDto.prototype, "confirmedRead", void 0);
__decorate([
    IsBoolean(),
    Equals(true),
    __metadata("design:type", Boolean)
], ActivateAiDocumentationDto.prototype, "declaresAuthority", void 0);
//# sourceMappingURL=activate-ai-documentation.dto.js.map